import { router } from "@inertiajs/react"

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { leagueTeamPlayerPath } from "@/routes"
import type { TeamPlayer } from "@/types"

interface FirePlayerDialogProps {
  player: TeamPlayer
  leagueId: string
  teamId: string
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function FirePlayerDialog({
  player,
  leagueId,
  teamId,
  open,
  onOpenChange,
}: FirePlayerDialogProps) {
  function handleFire() {
    void router.delete(leagueTeamPlayerPath(leagueId, teamId, player.id))
  }

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Fire {player.name}?</AlertDialogTitle>
          <AlertDialogDescription>
            This will permanently remove {player.name} from your roster. This
            cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
            onClick={handleFire}
          >
            Fire Player
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
